import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Button, ButtonToolbar, Row, Col } from 'react-bootstrap';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import { Translate } from 'react-redux-i18n';

import { DisabledInputField, InputField } from '../Common/inputField';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ConfirmActionModal from '../Common/confirmActionModal';
import SpinnerButton from '../Common/SpinnerButton';

let ConvertSlider = props => {
  let { input } = props;
  return (
    <Slider
      {...input}
      min={0}
      max={props.steps}
      step={1}
    />
  )
}

class ProductConvertDetail extends Component {

  static contextTypes = {
      router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      product1: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        selectedRow: null
      },
      product2: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        selectedRow: null
      },
      prod2Qty: null,
      numSteps: 10,

      // Value of conversion from product1
      conversionFrom1: null,
      // Value of conversion to product2
      conversionTo2: null,
    }
    this.handleProd2QtyChange = this.handleProd2QtyChange.bind(this);
    this.closeConfirm = this.closeConfirm.bind(this);
  }
  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.relatedProductsFetched && nextProps.relatedProductsFetched != this.props.relatedProductsFetched) {
      let rows1 = nextProps.relatedProductsFetched.Products.map(r => Object.assign({}, r));
      let rows2 = nextProps.relatedProductsFetched.Products.map(r => Object.assign({}, r));

      rows1 = rows1.filter(function(obj){
         return obj.ConvertNum && obj.InStock != null
      });
      rows2 = rows2.filter(function(obj){
         return obj.ConvertNum && obj.InStock != null
      });

      let product1 = {...this.state.product1, rows: rows1};
      let product2 = {...this.state.product2, rows: rows2};
      this.setState({product1, product2});
    }
    if((nextProps.Convert && nextProps.Convert != this.props.Convert) || nextProps.Convert == 0) {
      // let prod2Qty = this.state.product2.selectedRow && this.state.product2.selectedRow.InStock;
      // let prod2ConvertNum = this.state.product2.selectedRow && this.state.product2.selectedRow.ConvertNum;
      // prod2Qty = (prod2Qty || 0) + (nextProps.Convert || 0)*(prod2ConvertNum);
      // this.setState({prod2Qty})


      if (this.state.product1.selectedRow && this.state.product2.selectedRow) {
        this.props.setField("Prod1Qty", this.state.product1.selectedRow.InStock - (this.state.conversionFrom1 * nextProps.Convert));
        this.props.setField("Prod2Qty", this.state.product2.selectedRow.InStock + (this.state.conversionTo2 * nextProps.Convert));
      }
    }
  }

  closeConfirm() { this.setState({ confirmOpen: false }); }

  handleProd2QtyChange(event) {
    this.setState({prod2Qty: event.target.value})
  }

  submitConversion() {
    const itemConversion = {
      RelatedProductNum: this.state.product1.selectedRow.ProductNum,
      ProductNum: this.state.product2.selectedRow.ProductNum,
      RelatedQuantity: this.props.Prod1Qty - this.state.product1.selectedRow.InStock, //left
      Quantity: this.props.Prod2Qty - this.state.product2.selectedRow.InStock, //right
    }
    this.props.createNewConvert(itemConversion);
  }

  shouldDisableSaveButton(convertNum) {
    const selectedRow1 = this.state.product1.selectedRow;
    const selectedRow2 = this.state.product2.selectedRow;
    if (selectedRow1 && selectedRow2 && convertNum !== 0 && !this.props.inventoryConvertIsCreating) {
      return false;
    }
    return true;
  }

  renderProduct1() {
    if (this.props.lowInventoriesIsLoading && !this.props.lowInventoriesError) return (
      <div id="spinner">
        <Spinner/>
      </div>
    )
    else if (this.props.lowInventoriesError) return (
     <ContentWrapper>
       <div className="alert alert-danger">{JSON.stringify(this.props.lowInventoriesError)}</div>
     </ContentWrapper>
    )
    else {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.product1);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return Object.assign({Idx: rowIdx}, rows[rowIdx]);
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var product1 = Object.assign({}, this.state.product1, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({product1});
        }

        const handleRowUpdated = e => {
          let rows = getRows();
          Object.assign(rows[e.rowIdx], e.updated);
        }

        const onRowsSelected = (rows) => {
             let newRows = getRows();
             newRows.map(r => {
               if(r.ProductNum == rows[0].row.ProductNum)
                  r.isSelected = true
               else
                  r.isSelected = false;
             })
             let product1 = {...this.state.product1, rows: newRows, selectedRow: rows[0].row}
             this.setState({product1});
             this.props.setField('Convert', 0);
             this.props.setField('Prod1Qty', rows[0].row.InStock)
             if (this.state.product2.selectedRow) {
               this.props.setField('Prod2Qty', this.state.product2.selectedRow.InStock)
             }

             let prod2 = {...this.state.product2.selectedRow};
             let prod1 = {...rows[0].row};

             // Is this greater or lesser than 1?
             if (prod2) {
               if (prod1.ProductNum == prod2.ProductNum) {
                 this.setState({ numSteps: 0 });
                 return;
               }
               if (prod2.ConvertNum > prod1.ConvertNum) {
                 // Product1 convertNum < Product2 convertNum

                 // Check if prod1 evenly divides into Prod2
                //  if (prod2.ConvertNum % prod1.ConvertNum == 0) {

                    // Check for max number of conversions
                    if (prod1.InStock == 0 || prod1.InStock / (prod2.ConvertNum / prod1.ConvertNum) < 1) {
                      this.setState({ conversionFrom1: roundTo(prod2.ConvertNum / prod1.ConvertNum).toFixed(2), conversionTo2: 1, numSteps: 0});
                    } else {
                      this.setState({ conversionFrom1: roundTo(prod2.ConvertNum / prod1.ConvertNum).toFixed(2), conversionTo2: 1, numSteps: (prod1.InStock / (prod2.ConvertNum / prod1.ConvertNum)) });
                    }

                    if (prod2.ConvertNum % prod1.ConvertNum != 0) {
                      this.setState({ confirmOpen: true });
                    }
                //  } else {
                //    // Does not convert evenly!!
                //    this.setState({ numSteps: 0 })
                //  }

               } else if (prod2.ConvertNum < prod1.ConvertNum) {
                 // Product2 convertNum < Product1 convertNum

                 // Check if prod1 evenly divides into Prod2
                //  if (prod1.ConvertNum % prod2.ConvertNum == 0) {
                    this.setState({ conversionFrom1: 1, conversionTo2: roundTo(prod1.ConvertNum / prod2.ConvertNum).toFixed(2), numSteps: prod1.InStock });
                //  } else {
                //    // Does not convert evenly!!
                //    this.setState({ numSteps: 0 })
                //  }
                    if (prod1.ConvertNum % prod2.ConvertNum != 0) {
                      this.setState({ confirmOpen: true });
                    }
               } else {
                 // Product1 convertNum == Product2 convertNum
                 this.setState({ conversionFrom1: 1, conversionTo2: 1, numSteps: prod1.InStock });
               }
             }
        }

         const onRowsDeselected = (rows) => {
             let newRows = getRows();
             newRows.map (r => {
               r.isSelected = false;
             });
             let product1 = {...this.state.product1, rows: newRows, selectedRow: null}
             this.setState({product1});
         }

        // Column difinition

        const columns = [
          {
              key: 'ProductNum',
              name: <Translate value="prod_num" />,
              resizable: true,
              sortable: true,
              width: 100,
          },
          {
              key: 'PackageType',
              name: <Translate value="package_type" />,
              resizable: true,
              sortable: true,
              width: 220,
          },
          {
              key: 'PackageSize',
              name: <Translate value="package_size" />,
              resizable: true,
              sortable: true,
              width: 220,
          },
          {
              key: 'InStock',
              name: <Translate value="qty" />,
              resizable: true,
              sortable: true,
              width: 80,
          },
          {
              key: 'NetWeight',
              name: <Translate value="net_wt" />,
              resizable: true,
              sortable: true,
              width: 65,
          },
        ]

        return (
          <Row>
            <Col sm={ 12 }>
              <div id="ProductConvertDetail-dataGrid1">
                <ReactDataGrid
                    enableCellSelect={true}
                    onGridSort={handleGridSort}
                    columns={columns}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    rowSelection={{
                      showCheckbox: true,
                      onRowsSelected: onRowsSelected,
                      onRowsDeselected: onRowsDeselected,
                      selectBy: {
                        isSelectedKey: 'isSelected'
                      }
                    }}
                  />
              </div>
            </Col>
          </Row>
        )
    }
  }
  renderProduct2() {
    if (this.props.lowInventoriesIsLoading && !this.props.lowInventoriesError) return (
      <div id="spinner">
        <Spinner/>
      </div>
    )
    else if (this.props.lowInventoriesError) return (
     <ContentWrapper>
       <div className="alert alert-danger">{JSON.stringify(this.props.lowInventoriesError)}</div>
     </ContentWrapper>
    )
    else {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state.product2);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return Object.assign({Idx: rowIdx}, rows[rowIdx]);
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var product2 = Object.assign({}, this.state.product2, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState({product2});
        }

        const handleRowUpdated = e => {
          let rows = getRows();
          Object.assign(rows[e.rowIdx], e.updated);
        }

        const onRowsSelected = (rows) => {
             let newRows = getRows();
             newRows.map(r => {
               if(r.ProductNum == rows[0].row.ProductNum)
                  r.isSelected = true
               else
                  r.isSelected = false;
             })
             let product2 = {...this.state.product2, rows: newRows, selectedRow: rows[0].row}
             this.setState({product2});
             this.props.setField('Convert', 0);
             this.props.setField('Prod2Qty', rows[0].row.InStock);
             if (this.state.product1.selectedRow) {
               this.props.setField('Prod1Qty', this.state.product1.selectedRow.InStock);
             }
             let prod1 = {...this.state.product1.selectedRow};
             let prod2 = {...rows[0].row};

             // Is this greater or lesser than 1?
             if (prod1) {
               if (prod1.ProductNum == prod2.ProductNum) {
                 this.setState({ numSteps: 0 });
                 return;
               }
               if (prod2.ConvertNum > prod1.ConvertNum) {
                 // Product1 convertNum < Product2 convertNum

                 // Check if prod1 evenly divides into Prod2
                //  if (prod2.ConvertNum % prod1.ConvertNum == 0) {

                    // Check for max number of conversions
                    if (prod1.InStock == 0 || prod1.InStock / (prod2.ConvertNum / prod1.ConvertNum) < 1) {
                      this.setState({ conversionFrom1: roundTo(prod2.ConvertNum / prod1.ConvertNum).toFixed(2), conversionTo2: 1, numSteps: 0});
                    } else {
                      this.setState({ conversionFrom1: roundTo(prod2.ConvertNum / prod1.ConvertNum).toFixed(2), conversionTo2: 1, numSteps: (prod1.InStock / (prod2.ConvertNum / prod1.ConvertNum)) });
                    }

                    if (prod2.ConvertNum % prod1.ConvertNum != 0) {
                      this.setState({ confirmOpen: true });
                    }
                //  } else {
                //    // Does not convert evenly!!
                //    this.setState({ numSteps: 0 })
                //  }
               } else if (prod2.ConvertNum < prod1.ConvertNum) {
                 // Product2 convertNum < Product1 convertNum

                 // Check if prod1 evenly divides into Prod2
                //  if (prod1.ConvertNum % prod2.ConvertNum == 0) {
                    this.setState({ conversionFrom1: 1, conversionTo2: roundTo(prod1.ConvertNum / prod2.ConvertNum).toFixed(2), numSteps: prod1.InStock });
                //  } else {
                //    // Does not convert evenly!!
                //    this.setState({ conversionFrom1: 1, conversionTo2: (prod1.ConvertNum / prod2.ConvertNum), numSteps: prod1.InStock });
                //  }
                    if (prod1.ConvertNum % prod2.ConvertNum != 0) {
                      this.setState({ confirmOpen: true });
                    }
               } else {
                 // Product1 convertNum == Product2 convertNum
                 this.setState({ conversionFrom1: 1, conversionTo2: 1, numSteps: prod1.InStock });
               }
             }
        }

         const onRowsDeselected = (rows) => {
             let newRows = getRows();
             newRows.map (r => {
               r.isSelected = false;
             });
             let product2 = {...this.state.product2, rows: newRows, selectedRow: null}
             this.setState({product2});
         }

        // Column difinition

        const columns = [
          {
              key: 'ProductNum',
              name: <Translate value="prod_num" />,
              resizable: true,
              sortable: true,
              width: 100,
          },
          {
              key: 'PackageType',
              name: <Translate value="package_type" />,
              resizable: true,
              sortable: true,
              width: 220,
          },
          {
              key: 'PackageSize',
              name: <Translate value="package_size" />,
              resizable: true,
              sortable: true,
              width: 220,
          },
          {
              key: 'InStock',
              name: <Translate value="qty" />,
              resizable: true,
              sortable: true,
              width: 80,
          },
          {
              key: 'NetWeight',
              name: <Translate value="net_wt" />,
              resizable: true,
              sortable: true,
              width: 65,
          },
        ]

        return (
          <Row>
            <Col sm={ 12 }>
              <div id="ProductConvertDetail-dataGrid2">
                <ReactDataGrid
                    enableCellSelect={true}
                    onGridSort={handleGridSort}
                    columns={columns}
                    rowHeight={25}
                    rowGetter={rowGetter}
                    rowsCount={getSize()}
                    rowSelection={{
                      showCheckbox: true,
                      onRowsSelected: onRowsSelected,
                      onRowsDeselected: onRowsDeselected,
                      selectBy: {
                        isSelectedKey: 'isSelected'
                      }
                    }}
                  />
              </div>
            </Col>
          </Row>
        )
    }
  }
  render() {
    let createDialogStyle = {
        width: '500px',
        marginLeft: '-15%',
    };
    const prod1 = this.state.product1.selectedRow;
    const prod2 = this.state.product2.selectedRow;
    const confirmAction = (<Translate value="confirm_action" />);
    let prod1Qty = this.state.product1.selectedRow && this.state.product1.selectedRow.InStock;
    let prod1ConvertNum = this.state.product1.selectedRow && this.state.product1.selectedRow.ConvertNum;
    // prod1Qty = (prod1Qty || 0) - (this.props.Convert || 0)*(prod1ConvertNum || 0);
    let convert = 0;
    if(this.state.product1.selectedRow) {
      convert = (parseFloat(this.state.product1.selectedRow.InStock)-parseFloat(this.props.Prod1Qty));
    }
    return (
      <ContentWrapper>
        <Grid fluid="true" id="product-convert-detail">
          <Row>
            <ButtonToolbar>
              <SpinnerButton
                bsStyle="success"
                onClick={() => {
                  this.submitConversion();
                }}
                loading={this.props.inventoryConvertIsCreating}
                icon="fa-save"
                translation={<Translate value="save" />}
                disabled={this.shouldDisableSaveButton(convert)}
              />
              <Button bsStyle="danger" onClick={() => { this.context.router.push('/productConvertReport'); }}>
                <em className="fa fa-close" /><Translate value="cancel" />
              </Button>
              {/* <Button bsStyle="primary" >
                <Translate value="print" />
              </Button>
              <Button bsStyle="primary" >
                <Translate value="excel" />
              </Button> */}
            </ButtonToolbar>
          </Row>
          <Row>
            <h3><Translate value="product_num" /> {this.props.relatedProductsFetched.ProductNum}</h3>
          </Row>
          <Row>
            <h3>{this.props.relatedProductsFetched.Description}</h3>
          </Row>
          <Row>
            <h3>{this.props.relatedProductsFetched.Name}</h3>
          </Row>
          <Row>
            <Col md={ 6 }>
              { this.renderProduct1() }
            </Col>
            <Col md={ 6 }>
              { this.renderProduct2() }
            </Col>
          </Row>
          <Row>
            <Col md={ 3 }></Col>
            <Col md={ 1 } className="Convert">
              <label><Translate value="convert" /> : {convert}</label>
            </Col>
            <Col md={ 4 }>
              <Row>
                <Col md={ 3 } className="Product">
                  <label>{prod1 && prod1.ProductNum}</label>
                  <Field name="Prod1Qty" component={DisabledInputField} />
                </Col>
                <Col md={ 6 }>
                  <Row>
                    <label className="pull-left ml-xl">({prod1 && prod1.ConvertNum})</label>
                    <label className="pull-right mr-xl">({prod2 && prod2.ConvertNum})</label>
                  </Row>
                  <Row>
                    <Field name="Convert" steps={this.state.numSteps} component={ConvertSlider} />
                  </Row>
                </Col>
                <Col md={ 3 } className="Product">
                  <label>{prod2 && prod2.ProductNum}</label>
                  <Field name="Prod2Qty" component={InputField} />
                </Col>
              </Row>
            </Col>
            <Col md={ 4 }>
            </Col>
          </Row>
        </Grid>
        <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm() }} title={confirmAction}>
            <ConfirmActionModal
              case={"convertUneven"}
              closeC={this.closeConfirm} />
        </SkyLightStateless>
      </ContentWrapper>
    )

  }
}
export default ProductConvertDetail;

function roundTo(n, digits) {
 if (digits === undefined) {
   digits = 0;
 }

 var multiplicator = Math.pow(10, digits);
 n = parseFloat((n * multiplicator).toFixed(11));
 var test =(Math.round(n) / multiplicator);
 return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/productConvertDetail.jsx